import React from "react";
import ReactDOM from "react-dom/client";
import "@mantine/core/styles.css";
import '@mantine/dropzone/styles.css';
import { createTheme, MantineProvider } from "@mantine/core";
import { generateColors } from "@mantine/colors-generator";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource/raleway";
import "@fontsource/radio-canada"

const queryClient = new QueryClient()

const theme = createTheme({
    fontFamily: 'Raleway',
    headings: {
        sizes: {
            h6: {
                fontWeight: '100',
            }
        },
        fontFamily: 'Radio Canada'
    },
    colors: {
        background: generateColors("#33535e"),
        teal: [
            "#e5f9ff",
            "#d6eef6",
            "#b2dae7",
            "#8bc5d9",
            "#6ab4cc",
            "#54a9c5",
            "#46a3c2",
            "#348eac",
            "#257f9b",
            "#006f8a"
        ],
        dark: [
            '#cfd4d6',
            '#acaebf',
            '#8c8fa3',
            '#666980',
            '#256074',
            '#1f5060',
            '#19404d',
            '#061013',
            '#102830',
            '#01010a',
        ]
    },
    primaryColor: "teal"
});

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);

root.render(
    <React.StrictMode>
        <MantineProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </MantineProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();